import { useState, useEffect } from 'react';

export default function CampaignSection() {
  const [timeLeft, setTimeLeft] = useState({
    days: 15,
    hours: 23,
    minutes: 45,
    seconds: 30
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
        } else if (prev.hours > 0) {
          return { ...prev, hours: prev.hours - 1, minutes: 59, seconds: 59 };
        } else if (prev.days > 0) {
          return { ...prev, days: prev.days - 1, hours: 23, minutes: 59, seconds: 59 };
        }
        return prev;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const campaigns = [
    {
      card: '三井住友カード',
      benefit: '最大25,600円相当',
      detail: '新規入会&利用でVポイントプレゼント',
      color: 'from-teal-500 to-emerald-600',
      icon: 'ri-bank-card-line',
      link: '/mitsui',
      badge: '🔥 最高額',
      badgeColor: 'from-red-500 to-orange-500'
    },
    {
      card: '大手ECモール系カード',
      benefit: '5,000ポイント',
      detail: '新規入会&利用でポイント進呈',
      color: 'from-rose-500 to-pink-600',
      icon: 'ri-shopping-bag-line',
      link: '/ec-mall-card',
      badge: '⚡ 人気No.1',
      badgeColor: 'from-yellow-500 to-amber-500'
    },
    {
      card: '高還元率カード',
      benefit: '最大6,000ポイント',
      detail: '新規入会&利用で独自ポイント進呈',
      color: 'from-amber-500 to-orange-600',
      icon: 'ri-coupon-line',
      link: '/recruit',
      badge: '✨ 高還元',
      badgeColor: 'from-purple-500 to-pink-500'
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden">
      {/* 背景装飾 */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-1/4 w-48 sm:w-96 h-48 sm:h-96 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-1/4 w-48 sm:w-96 h-48 sm:h-96 bg-gradient-to-tr from-rose-500 to-pink-500 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      {/* 星の装飾 - モバイルでは数を減らす */}
      <div className="absolute inset-0 overflow-hidden hidden sm:block">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-white rounded-full animate-pulse"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 2}s`
            }}
          ></div>
        ))}
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        {/* ヘッダー */}
        <div className="text-center mb-8 sm:mb-12">
          <div className="inline-flex items-center gap-1.5 sm:gap-2 bg-gradient-to-r from-red-500 via-orange-500 to-yellow-500 text-white text-xs sm:text-sm font-bold px-4 sm:px-6 py-2 sm:py-3 rounded-full shadow-2xl shadow-orange-500/50 mb-4 sm:mb-6 animate-bounce">
            <i className="ri-fire-fill text-base sm:text-xl"></i>
            期間限定キャンペーン実施中
            <i className="ri-fire-fill text-base sm:text-xl"></i>
          </div>
          
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6 tracking-tight px-4">
            今月の
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-orange-400 to-red-400">
              超お得キャンペーン
            </span>
          </h2>
          
          {/* カウントダウンタイマー */}
          <div className="inline-block bg-gradient-to-r from-gray-800 to-gray-700 rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-2xl border border-gray-600 mb-4 sm:mb-6">
            <div className="text-yellow-400 text-xs sm:text-sm font-bold mb-2 sm:mb-3 flex items-center justify-center gap-1 sm:gap-2">
              <i className="ri-time-line text-sm sm:text-lg"></i>
              キャンペーン終了まで
            </div>
            <div className="flex gap-2 sm:gap-3 md:gap-4">
              <div className="text-center">
                <div className="bg-gradient-to-br from-red-500 to-orange-500 text-white text-lg sm:text-2xl md:text-3xl font-bold w-10 h-10 sm:w-14 sm:h-14 md:w-16 md:h-16 rounded-lg sm:rounded-xl flex items-center justify-center shadow-lg">
                  {timeLeft.days}
                </div>
                <div className="text-gray-400 text-[10px] sm:text-xs mt-1 sm:mt-2">日</div>
              </div>
              <div className="text-white text-lg sm:text-2xl md:text-3xl font-bold flex items-center">:</div>
              <div className="text-center">
                <div className="bg-gradient-to-br from-orange-500 to-yellow-500 text-white text-lg sm:text-2xl md:text-3xl font-bold w-10 h-10 sm:w-14 sm:h-14 md:w-16 md:h-16 rounded-lg sm:rounded-xl flex items-center justify-center shadow-lg">
                  {timeLeft.hours}
                </div>
                <div className="text-gray-400 text-[10px] sm:text-xs mt-1 sm:mt-2">時間</div>
              </div>
              <div className="text-white text-lg sm:text-2xl md:text-3xl font-bold flex items-center">:</div>
              <div className="text-center">
                <div className="bg-gradient-to-br from-yellow-500 to-green-500 text-white text-lg sm:text-2xl md:text-3xl font-bold w-10 h-10 sm:w-14 sm:h-14 md:w-16 md:h-16 rounded-lg sm:rounded-xl flex items-center justify-center shadow-lg">
                  {timeLeft.minutes}
                </div>
                <div className="text-gray-400 text-[10px] sm:text-xs mt-1 sm:mt-2">分</div>
              </div>
              <div className="text-white text-lg sm:text-2xl md:text-3xl font-bold flex items-center">:</div>
              <div className="text-center">
                <div className="bg-gradient-to-br from-green-500 to-teal-500 text-white text-lg sm:text-2xl md:text-3xl font-bold w-10 h-10 sm:w-14 sm:h-14 md:w-16 md:h-16 rounded-lg sm:rounded-xl flex items-center justify-center shadow-lg animate-pulse">
                  {timeLeft.seconds}
                </div>
                <div className="text-gray-400 text-[10px] sm:text-xs mt-1 sm:mt-2">秒</div>
              </div>
            </div>
          </div>

          <p className="text-gray-300 text-sm sm:text-base md:text-lg px-4">
            現在、以下のカードで入会特典キャンペーン実施中です
          </p>
        </div>

        {/* キャンペーンカード */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8 mb-8 sm:mb-12 md:mb-16">
          {campaigns.map((campaign, index) => (
            <a
              key={index}
              href={campaign.link}
              className="group block"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl hover:shadow-[0_0_40px_rgba(255,255,255,0.3)] transition-all duration-500 border border-gray-700 hover:border-transparent hover:-translate-y-1 sm:hover:-translate-y-3 hover:scale-[1.02] sm:hover:scale-105">
                {/* バッジ */}
                <div className={`absolute top-3 right-3 sm:top-4 sm:right-4 bg-gradient-to-r ${campaign.badgeColor} text-white text-[10px] sm:text-xs font-bold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full shadow-lg z-10 animate-pulse`}>
                  {campaign.badge}
                </div>

                {/* 光の効果 */}
                <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                {/* ヘッダー */}
                <div className={`relative bg-gradient-to-br ${campaign.color} p-5 sm:p-6 md:p-8 text-white overflow-hidden`}>
                  <div className="absolute top-0 right-0 w-20 sm:w-32 h-20 sm:h-32 bg-white/10 rounded-full blur-2xl"></div>
                  <div className="absolute bottom-0 left-0 w-16 sm:w-24 h-16 sm:h-24 bg-white/10 rounded-full blur-xl"></div>
                  
                  <div className="relative">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 bg-white/20 backdrop-blur-sm rounded-xl sm:rounded-2xl flex items-center justify-center mb-3 sm:mb-4 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-lg">
                      <i className={`${campaign.icon} text-xl sm:text-2xl md:text-3xl`}></i>
                    </div>
                    <div className="text-xs sm:text-sm font-semibold mb-1 sm:mb-2 opacity-90">
                      {campaign.card}
                    </div>
                    <div className="text-2xl sm:text-3xl md:text-4xl font-bold mb-2 sm:mb-3 drop-shadow-lg">
                      {campaign.benefit}
                    </div>
                    <div className="text-xs sm:text-sm opacity-90 leading-relaxed">
                      {campaign.detail}
                    </div>
                  </div>

                  {/* 波の装飾 */}
                  <div className="absolute bottom-0 left-0 right-0 h-6 sm:h-8 bg-gradient-to-t from-gray-800 to-transparent"></div>
                </div>
                
                {/* フッター */}
                <div className="p-4 sm:p-5 md:p-6 relative">
                  <div className="flex items-center justify-between mb-3 sm:mb-4">
                    <div className="flex items-center gap-1 text-yellow-400 text-xs sm:text-sm">
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-half-fill"></i>
                      <span className="text-gray-400 ml-1 text-[10px] sm:text-xs">(4.5)</span>
                    </div>
                    <div className="text-green-400 text-[10px] sm:text-xs font-bold flex items-center gap-1">
                      <i className="ri-checkbox-circle-fill"></i>
                      申込受付中
                    </div>
                  </div>

                  <div className="flex items-center justify-center gap-2 bg-gradient-to-r from-white to-gray-100 text-gray-900 font-bold py-3 sm:py-4 rounded-lg sm:rounded-xl group-hover:from-yellow-400 group-hover:to-orange-400 group-hover:text-white transition-all duration-300 shadow-lg group-hover:shadow-2xl text-sm sm:text-base">
                    <span>今すぐ申し込む</span>
                    <i className="ri-arrow-right-line group-hover:translate-x-1 sm:group-hover:translate-x-2 transition-transform duration-300"></i>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* 注意喚起 */}
        <div className="relative bg-gradient-to-br from-yellow-500/20 via-orange-500/20 to-red-500/20 backdrop-blur-sm rounded-2xl sm:rounded-3xl p-5 sm:p-8 md:p-10 text-center border border-yellow-500/30 overflow-hidden shadow-2xl">
          <div className="absolute inset-0 bg-gradient-to-br from-yellow-500/5 to-red-500/5 animate-pulse"></div>
          
          <div className="relative">
            <div className="inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-xl sm:rounded-2xl mb-4 sm:mb-6 shadow-2xl animate-bounce">
              <i className="ri-alarm-warning-line text-2xl sm:text-3xl md:text-4xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-white mb-3 sm:mb-4 px-2">
              キャンペーンは予告なく終了する場合があります
            </h3>
            <p className="text-gray-300 mb-5 sm:mb-6 md:mb-8 text-xs sm:text-sm md:text-base lg:text-lg leading-relaxed max-w-2xl mx-auto px-2">
              終了日未定のため早めの申込がおすすめです<br className="hidden sm:block" />
              特典を受け取るには条件達成が必要です
            </p>
            <button
              onClick={() => {
                const rankingSection = document.getElementById('ranking-section');
                if (rankingSection) {
                  rankingSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="inline-flex items-center gap-2 sm:gap-3 bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 hover:from-yellow-500 hover:via-orange-600 hover:to-red-600 text-white font-bold px-6 sm:px-10 md:px-12 py-3 sm:py-4 md:py-5 lg:py-6 rounded-full transition-all duration-300 shadow-2xl shadow-orange-500/50 hover:shadow-[0_0_50px_rgba(251,146,60,0.8)] hover:scale-105 whitespace-nowrap cursor-pointer text-sm sm:text-base md:text-lg w-full sm:w-auto justify-center"
            >
              <i className="ri-flashlight-fill text-lg sm:text-xl md:text-2xl"></i>
              <span>最新キャンペーンを確認</span>
              <i className="ri-arrow-right-line text-base sm:text-lg md:text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
